import {
    ADD_STATE,
    GET_STATES,
    GET_STATE,
    UPDATE_STATE,
    DELETE_STATE,
  } from "../types";
  
  const initialState = { list: [], single: null, totalCount: 0};
  
  const reducer = (state = initialState, action) => {
    const { type, payload, totalCount } = action;
  
    switch (type) {
      case GET_STATES:
        return { ...state, list: payload.data, totalCount: totalCount , pagination: payload.pagination};
  
      case GET_STATE:
        return { ...state, single: payload || initialState.single };
  
      case UPDATE_STATE:
        return {
          ...state,
          list: state.list.map((item) =>
            item.id === payload.id ? payload : item
          ),
        };
  
      case ADD_STATE:
        return {
          ...state,
          list: [payload, ...state.list],
        totalCount: state.totalCount + 1
        };
  
      case DELETE_STATE:
        return {
          ...state,
          list: state.list.filter((item) => item.id !== payload.id),
          totalCount: state.totalCount - 1
        };
  
      default:
        return state;
    }
  };
  
  export default reducer;
  